<div class="title">سطح فعالیت خود را انتخاب کنید</div>
<div class="container">
  <app-button
    *ngFor="let configButton of configButtons"
    [config]="configButton"
    class="button"
  ></app-button>
</div>
